import { FC, Key } from "react";

import { Flex } from "antd";

import DuplicateTransactions from "./DuplicateTransactions";
import RefreshAddress from "./RefreshAddress";
import ValidateUpdates from "./ValidateUpdates";

const TransactionUpdateActions: FC<{ selectedRowKeys: Key[] }> = ({
  selectedRowKeys,
}) => {
  const ids = selectedRowKeys.map((k) => k.toString());

  return (
    <Flex gap={16}>
      <ValidateUpdates ids={ids} />
      <DuplicateTransactions ids={ids} />
      <RefreshAddress ids={ids} />
    </Flex>
  );
};
export default TransactionUpdateActions;
